import AggregateRating from './aggregateRating';
import Branch from './branch';
import removeAccents from 'remove-accents';

export default function ServiceInfo(data){
    let service = data || {};
    this.id = service.id;
    this.defaultId = service.defaultId;
    this.name = service.name;
    this.nameNoAccents = service?.name ? removeAccents(service.name).toLowerCase().replace(/\s/gi, "") : undefined;
    this.description = service.description;
    this.aggregateRating = new AggregateRating(service.aggregateRating);
    this.branches = service.branches !== undefined && service.branches.length > 0 ? service.branches.map(b => new Branch(b)): service.sportsClubs !== undefined && service.sportsClubs.length >0 ? service.sportsClubs.map(b => new Branch(b)) : [];
}